import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import * as moment from 'moment';
import {getLabelsProj, SearchModel} from 'src/app/domain/appeloffre/proj-prog-search';
import {CriteriaSearch} from 'src/app/domain/CriteriaSearch';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {icons} from 'src/app/ui/icons';
import {CommmCode} from 'src/app/utils/constante/CommonCode';
import {SharedSearchService} from '../../accueil/common/shared-search.service';

@Component({
    selector: 'app-projet-prog-filtre',
    templateUrl: './projet-prog-filtre.component.html',
    styleUrls: ['./projet-prog-filtre.component.css']
})
export class ProjetProgFiltreComponent implements OnInit {
    panelOpenState = false;
    @Output() search = new EventEmitter<Array<CriteriaSearch>>();

    commmCode = CommmCode;
    form = this.formBuilder.group({
        planNo: this.formBuilder.control(null),

        pbkStrFr: this.formBuilder.control(null),
        epPlanMasterId: this.formBuilder.control(null),
        bizKindNmFr: this.formBuilder.control(null),
        planNmFr: this.formBuilder.control(null),
        planModSeq: this.formBuilder.control(null),
        bizKindNmId: this.formBuilder.control(null),
        planNmEn: this.formBuilder.control(null),
        bizKind: this.formBuilder.control(null),
        smallBizYn: this.formBuilder.control(null),
        executionPlaceStrFr: this.formBuilder.control(null),
        instNm: this.formBuilder.control(null),
        planNmAr: this.formBuilder.control(null),
        financialMethodStrFr: this.formBuilder.control(null),
        publicDt_end: this.formBuilder.control(null),
        publicDt: this.formBuilder.control(null),
        planYear: this.formBuilder.control(null),
        bidExecutionExpDt: this.formBuilder.control(null),
        bidExecutionExpDt_end: this.formBuilder.control(null),
    });
    labels = getLabelsProj();
    filteredVariables = [];
    icons = icons;
    variables = ['200', '220'];

    constructor(private formBuilder: FormBuilder, private apptranstlte: AppTranslateService,
                private sharedService: SharedSearchService) {
    }

    ngOnInit() {
    }

    getFormControl(key: keyof SearchModel) {
        return this.form.get(key) as FormControl;
    }

    submit() {
        const options = [];

        if (this.form.value.publicDt != undefined || this.form.value.publicDt != null) {
            var date_formatted_publicDt_start = moment(this.form.value.publicDt._d).format('YYYY-MM-DD');
        }
        if (this.form.value.publicDt_end != undefined || this.form.value.publicDt_end != null) {
            var date_formatted_publicDt_end = moment(this.form.value.publicDt_end._d).format('YYYY-MM-DD');
        }
        if (this.form.value.bdRecvEndDt != undefined || this.form.value.bdRecvEndDt != null) {
            var date_formatted_bdRecvEndDt = moment(this.form.value.bdRecvEndDt._d).format('YYYY-MM-DD');
        }
        if (this.form.value.bdRecvEndDt_end != undefined || this.form.value.bdRecvEndDt_end != null) {
            var date_formatted_bdRecvEndDtt_end = moment(this.form.value.bdRecvEndDt_end._d).format('YYYY-MM-DD');
        }


        if (this.form.value.bidExecutionExpDt != undefined || this.form.value.bidExecutionExpDt != null) {
            var date_formatted_bidExecutionExpDt_start = moment(this.form.value.bidExecutionExpDt._d).format('YYYY-MM-DD');
        }
        if (this.form.value.bidExecutionExpDt_end != undefined || this.form.value.bidExecutionExpDt_end != null) {
            var date_formatted_bidExecutionExpDt_end = moment(this.form.value.bidExecutionExpDt_end._d).format('YYYY-MM-DD');
        }


        if (this.form.value.smallBizYn == 'oui' || this.form.value.smallBizYn == 'Yes' || this.form.value.smallBizYn == 'نعم') {
            var val_pme = 'Y';
        }
        if (this.form.value.smallBizYn == 'non' || this.form.value.smallBizYn == 'No' || this.form.value.smallBizYn == 'لا') {
            var val_pme = 'N';
        }



        options.push(
            new CriteriaSearch(
                'planNo',
                this.form.value.planNo || undefined,
                'upper_like'
            ),
            new CriteriaSearch(
                'bizKindNmId',
                this.form.value.bizKindNmFr || undefined,
                'upper_like'
            ),

            new CriteriaSearch(
                'bizKindNmId',
                this.form.value.bizKindNmAr || undefined,
                'upper_like'
            ),
            new CriteriaSearch(
                'executionPlaceStrId',
                this.form.value.executionPlaceStrId || undefined,
                'equals'
            ),
            new CriteriaSearch(
                'pbkStrId',
                this.form.value.pbkStrFr || undefined,
                'equals'
            )
            ,
            new CriteriaSearch(
                'pbkStrId',
                this.form.value.pbkStrAr || undefined,
                'equals'
            )
            ,
            new CriteriaSearch(
                'publicDt',
                date_formatted_publicDt_start || undefined,
                '>'
            ),
            new CriteriaSearch(
                'publicDt',
                date_formatted_publicDt_end || undefined,
                '<'
            ),
            new CriteriaSearch(
                'bdRecvEndDt',
                date_formatted_bdRecvEndDt || undefined,
                '>'
            ),

            new CriteriaSearch(
                'financialMethodStrId',
                this.form.value.financialMethodStrFr || undefined,
                '='
            ),
            new CriteriaSearch(
                'executionPlaceStrId',
                this.form.value.executionPlaceStrFr || undefined,
                '='
            )
            ,
            new CriteriaSearch(
                'executionPlaceStrId',
                this.form.value.executionPlaceStAr || undefined,
                '='
            )
            ,
            new CriteriaSearch(
                'planNmFr',
                this.form.value.planNmFr || undefined,
                'upper_like'
            ),
            new CriteriaSearch(
                'planNmAr',
                this.form.value.planNmAr || undefined,
                'upper_like'
            ),
            new CriteriaSearch(
                'onOffTypeStrId',
                this.form.value.onOffTypeStrId,
                '='
            ),
            new CriteriaSearch(
                'instNm',
                this.form.value.instNm,
                'upper_like'
            )
            ,
            new CriteriaSearch(
                'planYear',
                this.form.value.planYear,
                'equals'
            )
            ,
            new CriteriaSearch(
                'smallBizYn',
                val_pme,
                'equals'
            ),
            new CriteriaSearch(
                'bidExecutionExpDt',
                date_formatted_bidExecutionExpDt_start || undefined,
                '>'
            ),
            new CriteriaSearch(
                'bidExecutionExpDt',
                date_formatted_bidExecutionExpDt_end || undefined,
                '<'
            ),
        );
        this.search.emit(options);

    }

    getlang() {

        return this.apptranstlte.getDefaultLang() == 'ar'
    }


    reset() {
        // this.sharedService.updatecompProjetVal(undefined);
        this.form.reset();
        this.submit();
    }
}
